<script module>
  export const meta = {
    title: 'Invoices',
    teaser:
      'This page outlines the automatic generation and customization options of\ninvoices post-transaction, emphasizing options for VAT ID addition, company\ndetails personalization, and easy access and management for user convenience and\nregulatory compliance.',
    sort: 3,
  }
</script>

<p>
  When you complete a transaction, an invoice is automatically generated and
  sent to you. This process ensures you have a detailed record of your payment,
  including all the necessary transaction details.
</p>
<p>
  For those who require meticulous financial records, you have the option to add
  a VAT ID to your invoice. This feature is especially useful for keeping your
  accounting accurate and in compliance with tax regulations.
</p>
<p>
  Furthermore, if you wish to personalize your invoices, there is an option to
  include your company's name and address, making them suitable for official
  purposes.
</p>
<p>
  We understand the importance of having control over your financial documents.
  Therefore, we've made it straightforward for you to access and manage your
  invoices whenever necessary, ensuring a seamless and hassle-free experience.
</p>
